import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import CheckoutService from 'Services/checkout';
import RecordsService from 'Services/records';
import { history, store } from 'Store';
import { setStageAction } from 'Store/modules/validations/actions';
import { FRONT_PLANS } from 'Constants/plans';
import { routes } from 'Constants/routes';
import { QueryKeys, ResponseType, ResultTypes, SubmitResultType } from 'Types/common';

export interface subscribeFlexLiteProps {
  taxReturnType: string;
  taxReturnResult: number;
  notIsToReturn: boolean;
}

export const useSubscribeLiteFlexCheckout = ({
  data,
}: {
  data: subscribeFlexLiteProps;
}): UseMutationResult<ResponseType<unknown>, { taxYear: string; type: string }> => {
  return useMutation([QueryKeys.SUBSCRIBE_FLEX_LITE_CHECKOUT], CheckoutService.subscribeLiteFlex, {
    onSuccess: () => {
      const successUrl = `${routes.CHECKOUT_SUCCESS_STEP}?filing=true&plans=${FRONT_PLANS.FLEX_LITE}`;
      history.push(successUrl, {
        taxReturnType: data?.taxReturnType,
        taxReturnResult: data?.taxReturnResult,
        isExtendedFlexLite: !data?.notIsToReturn,
        isExtendedAndIsToReturn: data?.taxReturnType === ResultTypes.toReturn,
      });
    },
  });
};

export const useSubmitDeclarationCheckout = (): UseMutationResult<ResponseType<SubmitResultType>> =>
  useMutation([QueryKeys.SUBMIT_ANUAL_DECLARATION_CHECKOUT], RecordsService.setSubmit, {
    onSuccess: data => {
      const response = data.data;
      store.dispatch(setStageAction(response.item.stage));
    },
  });
